export const getDot = (data) => data.dot || ''

export const getMc = (data) => data.mc || ''

export const getName = (data) => data.legalName || ''


// WEBPACK FOOTER //
// ./src/misc/dot.js